import { Link } from "react-router-dom";
import useSeo from "@/hooks/useSeo";

const VALUES = [
  { icon: "ri-flashlight-fill", title: "独家优先", desc: "坚持独家首发，能抢第一时间，绝不让读者等第二时间。现场能直击，就不转载二手消息。" },
  { icon: "ri-shield-check-line", title: "真实至上", desc: "所有内容先核实、后发布。宁可慢半拍，也不为了流量牺牲基本事实与职业道德。" },
  { icon: "ri-eye-line", title: "细节洞察", desc: "不只报「发生了什么」，更想讲清「背后为什么」。用细腻视角呈现娱乐圈的另一面。" },
  { icon: "ri-heart-line", title: "尊重边界", desc: "关注人物与作品，不猎奇、不越界。对明星与普通人都保有最基本的尊重与温度。" },
];

const FAQS = [
  { q: "娱乐爆料的内容原则是什么？", a: "我们奉行「独家优先、真实至上、尊重边界」三大原则：能现场直击就亲自去，无法确认的内容坚决不发布，涉及隐私与敏感信息一律谨慎处理。" },
  { q: "为什么我有时在别处看不到这些资讯？", a: "因为部分内容属于我们编辑部通过自身信源获取的独家首发，会比其他渠道更早、更完整。这也是我们「第一手资讯抢先看」的核心价值。" },
  { q: "如何联系娱乐爆料？", a: "你可以通过页面底部或联系我们板块中的邮箱 contact@entertainment.example.com 与我们取得联系，无论是投稿、线索还是合作洽谈都欢迎。" },
];

export default function AboutPage() {
  useSeo({
    title: "关于我们 - 娱乐爆料 · 独家首发第一手娱乐资讯",
    description: "了解娱乐爆料的品牌定位、发展理念与内容原则。娱乐爆料专注娱乐行业第一手资讯，以独家首发为核心，坚持现场直击、交叉核实与真实表达。",
    keywords: "娱乐爆料,关于我们,品牌介绍,娱乐资讯平台",
  });

  const aboutSchema = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: "关于娱乐爆料",
    description: "娱乐爆料的品牌介绍、发展理念与内容原则。",
  };

  return (
    <div>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutSchema) }} />
      {/* hero */}
      <section className="bg-foreground-950">
        <div className="mx-auto flex max-w-7xl flex-col items-center px-4 py-16 text-center md:px-6 md:py-20">
          <span className="text-xs font-bold uppercase tracking-widest text-primary-400">About Us</span>
          <h1 className="mt-3 max-w-3xl text-2xl font-black leading-snug text-background-50 md:text-4xl">
            关于<span className="text-primary-400">娱乐爆料</span>
          </h1>
          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
            娱乐爆料是一个专注娱乐行业第一手资讯的华语平台。我们相信，真正的好内容不是被推送到眼前的标题，而是被用心采集、核实与讲述的现场故事。
          </p>
        </div>
      </section>

      {/* 品牌介绍 */}
      <section className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-4 py-14 md:px-6 lg:grid-cols-2">
        <div className="order-2 lg:order-1">
          <span className="text-xs font-bold uppercase tracking-widest text-primary-600">Our Story</span>
          <h2 className="mt-3 text-2xl font-black leading-snug text-foreground-950 md:text-3xl">从「抢首发」到「讲好故事」的每一步</h2>
          <div className="mt-5 space-y-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            <p>娱乐爆料的起点，是一群对娱乐圈既好奇又较真的编辑。我们不满于只做搬运工式的资讯集合，而是希望真正走到片场、后台与演出现场，用第一视角记录那些转瞬即逝的瞬间。</p>
            <p>成立至今，我们逐步建立起覆盖剧集、电影、音乐与综艺的采编网络。从一条热搜背后的来龙去脉，到颁奖礼后台不为人知的真实情绪，我们努力让每一篇报道都有现场、有细节、有态度。</p>
            <p>今天的娱乐爆料，已经从单一资讯页成长为集栏目、专访与深度报道于一体的娱乐内容平台，服务着越来越多渴望「看见真实娱乐圈」的读者。</p>
          </div>
        </div>
        <div className="order-1 grid grid-cols-2 gap-4 lg:order-2">
          {[
            { src: "https://readdy.ai/api/search-image?query=Modern%20newsroom%20with%20creative%20young%20asian%20journalists%20collaborating%20at%20desks%2C%20laptop%20screens%20and%20mood%20boards%2C%20warm%20natural%20light%2C%20dynamic%20editorial%20atmosphere&width=600&height=420&seq=about-team-x1&orientation=landscape", alt: "娱乐爆料编辑团队工作场景" },
            { src: "https://readdy.ai/api/search-image?query=Journalist%20holding%20microphone%20at%20an%20outdoor%20red%20carpet%20event%20with%20camera%20crews%20and%20stage%20lights%2C%20evening%20event%20atmosphere%2C%20press%20coverage%20scene&width=600&height=420&seq=about-live-x1&orientation=landscape", alt: "娱乐爆料记者现场采访拍摄场景" },
          ].map((img, i) => (
            <div key={i} className={`overflow-hidden rounded-lg ${i === 0 ? "row-span-1" : "row-span-1"}`}>
              <img src={img.src} alt={img.alt} loading="lazy" className="h-full w-full object-cover" />
            </div>
          ))}
        </div>
      </section>

      {/* 价值观 */}
      <section className="border-y border-background-200 bg-background-100">
        <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
          <div className="text-center">
            <span className="text-xs font-bold uppercase tracking-widest text-primary-600">Our Values</span>
            <h2 className="mt-3 text-2xl font-black text-foreground-950 md:text-3xl">我们坚持的四件事</h2>
          </div>
          <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {VALUES.map((v) => (
              <div key={v.title} className="rounded-lg bg-background-50 p-6">
                <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-500 text-background-50"><i className={`${v.icon} text-xl`}></i></span>
                <h3 className="mt-4 text-lg font-bold text-foreground-950">{v.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 数据与联系方式 */}
      <section className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
          <div className="rounded-lg bg-primary-600 p-8 text-background-50">
            <h2 className="text-xl font-black md:text-2xl">联系我们 / 投稿爆料</h2>
            <p className="mt-3 text-sm leading-relaxed text-background-100">
              无论你是想提供独家线索、反馈建议，还是有深度内容希望与我们合作，都欢迎通过以下方式找到我们。
            </p>
            <div className="mt-6 space-y-3">
              <a href="mailto:contact@entertainment.example.com" className="flex items-center gap-3 rounded-lg bg-background-50/10 p-3 transition-colors hover:bg-background-50/20">
                <i className="ri-mail-line text-xl"></i>
                <div>
                  <p className="text-xs text-background-100">工作邮箱</p>
                  <p className="text-sm font-semibold">contact@entertainment.example.com</p>
                </div>
              </a>
              <a href="https://weibo.com" rel="nofollow noopener" target="_blank" className="flex items-center gap-3 rounded-lg bg-background-50/10 p-3 transition-colors hover:bg-background-50/20">
                <i className="ri-weibo-fill text-xl"></i>
                <div>
                  <p className="text-xs text-background-100">官方微博</p>
                  <p className="text-sm font-semibold">@娱乐爆料官方</p>
                </div>
              </a>
              <a href="https://weixin.qq.com" rel="nofollow noopener" target="_blank" className="flex items-center gap-3 rounded-lg bg-background-50/10 p-3 transition-colors hover:bg-background-50/20">
                <i className="ri-wechat-fill text-xl"></i>
                <div>
                  <p className="text-xs text-background-100">微信公众号</p>
                  <p className="text-sm font-semibold">搜索「娱乐爆料」</p>
                </div>
              </a>
            </div>
          </div>
          <div>
            <h2 className="text-xl font-black text-foreground-950 md:text-2xl">用户常见问题</h2>
            <div className="mt-5 space-y-3">
              {FAQS.map((f) => (
                <div key={f.q} className="rounded-lg border border-background-200 bg-background-50 p-5">
                  <h3 className="flex items-start gap-2 text-sm font-bold text-foreground-950">
                    <i className="ri-question-line mt-0.5 text-primary-600"></i>{f.q}
                  </h3>
                  <p className="mt-2 pl-6 text-sm leading-relaxed text-foreground-600">{f.a}</p>
                </div>
              ))}
            </div>
            <div className="mt-6 flex flex-wrap items-center gap-3 rounded-lg bg-background-100 p-5">
              <p className="flex-1 text-sm font-medium text-foreground-700">想先看看我们的独家内容？</p>
              <Link to="/category/exclusive" className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600">
                浏览独家爆料
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}